/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { QueryParam, withScope } from '@bingads-webui-react/scope-service';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';


const WalkMe = (props) => {
  const [isInitialized, setInitialized] = useState(false);
  const { serverContext, scope } = props;

  useEffect(() => {
    if (isInitialized) {
      if (scope.values.walkMeId) {
        if (window.WalkMeAPI && ((typeof window.WalkMeAPI.startWalkthruById !== 'function') || !window.WalkMeAPI.startWalkthruById(scope.values.walkMeId))) {
          // if regular walkthrough does not exist, do smart walkthrough flow
          window.WalkMeAPI.startFlowById(scope.values.walkMeId);
        }
        scope.remove('walkMeId');
        scope.save();
      }
    } else {
      window.walkme_ready = () => {
        // exposing user id together with customer id and account id to walkme
        const userId = `${serverContext.CurrentUser.Id}_${serverContext.CurrentCustomer.Id}_${serverContext.CurrentAccount.AccountNumber}`;

        window._userId = userId;
        let language;

        if (serverContext.CurrentLocale) {
          language = serverContext.CurrentLocale.substr(0, 2).toLowerCase();
          if (language === 'en') {
            language = ''; // default for english
          }

          const currentLanguage = window.WalkMeAPI.getCurrentLanguage();

          if (language !== currentLanguage) {
            window.WalkMeAPI.changeLanguage(language);
          }
        }
        setInitialized(true);
        document.querySelectorAll('.walkme-to-destroy').forEach(walmeToDestory => walmeToDestory.remove());
      };

      if (window.WalkMeAPI) {
        window.walkme_ready();
        delete window.walkme_ready;
      }
    }
  });

  return null;
};

WalkMe.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      Id: PropTypes.number.isRequired,
    }),
    CurrentCustomer: PropTypes.shape({
      Id: PropTypes.number.isRequired,
    }),
    CurrentUser: PropTypes.shape({
      Id: PropTypes.number.isRequired,
    }),
    CurrentLocale: PropTypes.string,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
};

export const WalkMeWithScopeAndContext = withServerContext(withScope(WalkMe));
